<app-modal>
  <h1 class="h2" *ngIf="task.scheduleCreateDaysBeforeEventStart === null">Add task</h1>
  <h1 class="h2" *ngIf="task.scheduleCreateDaysBeforeEventStart !== null">Edit scheduled task</h1>

  <div class="mt-0100 mb-0025" [formGroup]="taskForm">

    <p>When do you want to create the
      <strong>
        <i class="far fa-fw color--green--002" [ngClass]="getTaskIconClass(task.actionPurpose)"></i>
        {{ getTaskDisplayLabel(task.actionPurpose) }}
      </strong>
      task?
    </p>

    <mat-radio-group class="d-flex flexDirection-column mb-0150" formControlName="taskType">
      <mat-radio-button value="schedule" class="mb-0100">Schedule task
        <ng-container *ngIf="task.actionPurpose !== attendanceTaskPurpose">
          <mat-form-field class="no-label col__xs--15 mb-0">
            <input type="number" aria-label="Number" matInput formControlName="scheduleCreateDaysBeforeEventStart"
              min="0" [max]="daysMax" (blur)="validate()">
          </mat-form-field>
          day{{ taskForm.get('scheduleCreateDaysBeforeEventStart').value !== 1 ? 's' : '' }} before the event
        </ng-container>
        <ng-container *ngIf="task.actionPurpose === attendanceTaskPurpose">
          <mat-form-field class="no-label col__xs--15 mb-0">
            <input type="number" aria-label="Number" matInput formControlName="attendanceDaysAfterEventStart" min="0"
              (blur)="validate()">
          </mat-form-field>
          day{{ taskForm.get('attendanceDaysAfterEventStart').value !== 1 ? 's' : '' }} after the event starts
        </ng-container>
      </mat-radio-button>

      <mat-radio-button value="now">Create task now</mat-radio-button>
      <mat-radio-button *ngIf="task.scheduleCreateDaysBeforeEventStart !== null" class="color--red mt-0100"
        value="cancel">Cancel scheduled task</mat-radio-button>
    </mat-radio-group>

    <app-error-notification [errors]="getErrorMessages()" *ngIf="taskForm.invalid"></app-error-notification>

    <div class="row dual-btn-row with-gap mt-0100 flexJustify--end">
      <button type="button" class="btn btn--white" (click)="close()" [disabled]="isSubmitting">
        Cancel
      </button>
      <button type="button" class="btn mt-0" (click)="updateTask()" [disabled]="isSubmitting || !taskForm.valid">
        <span *ngIf="task.scheduleCreateDaysBeforeEventStart === null">Add task</span>
        <span *ngIf="task.scheduleCreateDaysBeforeEventStart !== null">Update task</span>
      </button>
    </div>

  </div>
</app-modal>
